import { toast } from "react-toastify";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { doc, setDoc, onSnapshot, updateDoc } from "firebase/firestore";
import { auth, firestore } from "../../config/firebase";
export const setLoading = (val: boolean) => async (dispatch: any) => {
  dispatch({
    type: "AUTH_LOADING",
    payload: val,
  });
};
export const registerUser =
  (creds: any, onSuccess: any) => async (dispatch: any) => {
    dispatch(setLoading(true));
    createUserWithEmailAndPassword(
      auth,
      creds?.personalInfo?.email,
      creds.password
    )
      .then((data) => {
        try {
          setDoc(doc(firestore, "visitors", data.user.uid), creds)
            .then((res) => {
              dispatch({
                type: "REGISTER_SUCCESS",
              });
              toast.success("Account Created Successfully");
              dispatch(setLoading(false));
              onSuccess(data?.user?.uid);
            })
            .catch((error) => {
              dispatch({
                type: "REGISTER_FAIL",
              });
              toast.warning(error.message);
              dispatch(setLoading(false));
            });
        } catch (e: any) {
          dispatch(setLoading(false));
          toast.warning(e.response.message);
        }
      })
      .catch((error) => {
        dispatch({
          type: "REGISTER_FAIL",
        });
        dispatch(setLoading(false));
        toast.warning(error.message);
      });
  };

export const registerSuccess = () => {
  return (dispatch: any) => {
    dispatch({
      type: "REGISTER_COMPLETE",
    });
  };
};

export const getLoginData = (id: any) => async (dispatch: any) => {
  onSnapshot(doc(firestore, "visitors", id), (doc: any) => {
    dispatch({
      type: "LOGIN_SUCCESS",
      payload: { docId: doc.id, ...doc.data() },
    });
    dispatch(setLoading(false));
  });
};

export const login = (creds: any) => {
  return async (dispatch: any) => {
    dispatch(setLoading(true));
    signInWithEmailAndPassword(auth, creds.email, creds.password)
      .then((data) => {
        try {
          dispatch(getLoginData(data.user.uid));
          localStorage.setItem("uid", data?.user?.uid);
        } catch (e: any) {
          dispatch({
            type: "LOGIN_FAIL",
          });
          dispatch(setLoading(false));
          toast.warning(e.message);
        }
      })
      .catch((error) => {
        dispatch({
          type: "LOGIN_FAIL",
        });
        dispatch(setLoading(false));
        toast.warning(error.message);
      });
  };
};

export const logout = () => {
  return (dispatch: any) => {
    signOut(auth)
      .then((data) => {
        dispatch({
          type: "LOGOUT_SUCCESS",
        });
      })
      .catch((error) => {
        dispatch({
          type: "LOGOUT_FAIL",
        });
        toast.warning(error.message);
      });
  };
};

export const updateUser = (id: any, obj: any) => async (dispatch: any) => {
  try {
    updateDoc(doc(firestore, "visitors", id), obj).then((res) => {
      toast.success("User Updated Successfully");
      return;
    });
  } catch (e: any) {
    toast.warning(e.repsonse.message);
  }
};
